import { Vue, Component } from "vue-property-decorator";

@Component
export default class BreadcrumbsMixin extends Vue {
  breadcrumbs = [] as string[];

  breadcrumbClicked(layer: string): void {
    const splitIndex = this.breadcrumbs.indexOf(layer);
    this.breadcrumbs.splice(splitIndex + 1);
  }

  get selectedLayer(): string {
    return this.breadcrumbs.length === 0
      ? ""
      : this.breadcrumbs[this.breadcrumbs.length - 1];
  }
}
